import {
  AccountModalConfig,
  AccountsModalConnectButtonComponent,
  AccountsModalErrorStateComponent,
  AccountsModalSearchButtonComponent,
} from '@celerofinancas/common-domain';
import { LINKS } from './environments-ref';

/**
 * CAIXA accounts modal: keeps the layout the custom layer had before the modal became
 * configurable (title, two totals, "Buscar" button, connect button on the header,
 * separate agency/account columns). Icons come from the CAIXA icon font.
 */
export const CAIXA_ACCOUNT_MODAL_CONFIG: AccountModalConfig = {
  onclick: () => {
    window.open(LINKS.open_finance, '_blank');
  },
  additionalFilters: [
    {
      priority_bank_id: '104',
    },
  ],
  partnerName: 'Caixa',
  copy: {
    title: 'Contas vinculadas | Caixa e Open Finance',
    subtitle: (_partnerName, count) => `(${count} Contas)`,
    scopeTooltip: () =>
      'Estão sendo exibidas as contas correntes da sua empresa, sejam contas Caixa ou de outras ' +
      'instituições financeiras, vinculadas via Open Finance. Apenas contas com consentimento ativo ' +
      'de compartilhamento de dados estão apresentadas.',
    searchPlaceholder: 'Pesquise por número da conta, apelido ou banco',
    totals: { available: 'Saldo Disponível', blocked: 'Saldo Bloqueado' },
    balanceTooltips: { available: '', blocked: '' },
    headers: {
      bank_id: 'Banco',
      agency: 'Ag',
      account: 'Conta',
      name: 'Apelido',
      available_balance: 'Saldo Disponível',
      blocked_balance: 'Saldo Bloqueado',
      to_show: 'Mostrar no cabeçalho',
    },
  },
  columns: [
    { name: 'bank_id', align: 'center', orderByfilter: false, valueRef: 'bank_id' },
    { name: 'agency', align: 'left', orderByfilter: false, valueRef: 'agency' },
    { name: 'account', align: 'left', orderByfilter: true, valueRef: 'bank_account' },
    { name: 'name', align: 'left', orderByfilter: false, valueRef: 'name' },
    {
      name: 'available_balance',
      align: 'right',
      orderByfilter: false,
      valueRef: 'bank_account_current_balance',
    },
    { name: 'blocked_balance', align: 'right', orderByfilter: false, valueRef: 'blocked_balance' },
    { name: 'to_show', align: 'center', orderByfilter: false, valueRef: 'to_show' },
  ],
  totals: ['available', 'blocked'],
  icons: {
    info: 'cds-icon-filled-question',
    search: 'v-hover c-icon-medium cds-icon-search v-compact',
  },
  loading: { count: 3, height: '135px' },
  slots: {
    headerEnd: [AccountsModalConnectButtonComponent],
    searchEnd: [AccountsModalSearchButtonComponent],
    afterTable: [],
    footerStart: [],
    footerEnd: [],
    error: [AccountsModalErrorStateComponent],
  },
};
